// ============================================
// FILE: /frontend/src/api/facebook.api.js
// PURPOSE: Facebook API client (mirrors whatsapp.api.js)
// ============================================

import apiClient from './client.js';

export const facebookAPI = {
  /**
   * Generate Facebook share message for single listing
   * @param {string} listingId - Listing ID
   * @returns {Promise<Object>} { message, trackingUrl, trackingId }
   */
  generateShareMessage: async (listingId) => {
    console.log('[Facebook API] 📤 Generating share message for:', listingId);
    const response = await apiClient.post('/facebook/share', { listingId });
    console.log('[Facebook API] ✅ Share message generated');
    return response.data;
  },

  /**
   * Generate bulk Facebook message for multiple listings
   * @param {string[]} listingIds - Array of listing IDs (max 6)
   * @returns {Promise<Object>} { message, trackingIds, listingsCount }
   */
  generateBulkMessage: async (listingIds) => {
    console.log('[Facebook API] 📤 Generating bulk message for:', listingIds.length, 'listings');
    const response = await apiClient.post('/facebook/bulk', { listingIds });
    console.log('[Facebook API] ✅ Bulk message generated');
    return response.data;
  },

  /**
   * Track click from Facebook link (public endpoint)
   * @param {string} trackingId - Tracking ID from URL
   * @returns {Promise<Object>} { success: boolean }
   */
  trackClick: async (trackingId) => {
    console.log('[Facebook API] 📊 Tracking click:', trackingId);
    const response = await apiClient.post('/facebook/track-click', { trackingId });
    console.log('[Facebook API] ✅ Click tracked');
    return response.data;
  },

  /**
   * Get user's Facebook sharing analytics
   * @returns {Promise<Object>} { totalShares, totalClicks, topListings, etc }
   */
  getAnalytics: async () => {
    console.log('[Facebook API] 📈 Fetching analytics');
    const response = await apiClient.get('/facebook/analytics');
    console.log('[Facebook API] ✅ Analytics fetched');
    return response.data;
  }
};